(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deventor-christmas-favourites"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('deventor-favourites-carousel')) {
  customElements.define('deventor-favourites-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('ul');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.buttons[0].disabled = this.track.scrollLeft <= 2;
        this.buttons[1].disabled = this.track.scrollLeft >= maximum - 2;
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const width = card.getBoundingClientRect().width + gap;
        const count = Math.max(1, Math.round(this.track.clientWidth / width));
        this.track.scrollBy({left: Number(button.dataset.direction) * width * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal}));
      this.track.addEventListener('scroll', update, {signal, passive:true});
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
